module.exports = __webpack_public_path__ + "media/images/official/special_migration_05-baf88105319fc060276b739e235e6b0b.jpg";